import { environment } from "../../../configs/variables"

export const configsAccival = {
merchantId : "263",
formId: "228",
terminalId: "284",
responseUrl: environment === 'PROD' ? "https://galilea.co/pagar" : "http://dev.galilea.co/pagar",
colorBase: "#DE073F",
currency: "COP",
urlAction: "https://merchantpruebas.vepay.com.co/cartaspago/redirect"
}

export const configsAccivalProd = {
    merchantId : environment === 'LOCAL' ? "263" : "1731",
    formId: environment === 'LOCAL' ? "228" : "1559",
    terminalId: environment === 'LOCAL' ? "284" : "1268",
    responseUrl: environment === 'PROD' ? "https://galilea.co/pagar" : "http://dev.galilea.co/pagar",
    colorBase: "#DE073F",
    currency: "COP",
    urlAction: environment === 'LOCAL' ? "https://merchantpruebas.vepay.com.co/cartaspago/redirect" : "https://merchant.accivalconnect.com/cartaspago/redirect"
    }